module.exports = __webpack_public_path__ + "statics/img/FullChain-5@2x.bd8544fe.png";